module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg3_mid.df78a00e.jpg";